import { Injectable } from '@angular/core';
import { Apollo } from 'apollo-angular';
import { map, Observable } from 'rxjs';
import { ACCOUNTS, GET_ACCOUNT_BY_ID } from '../graphql/queries/chart-accounts.query';
import { CREATE_CHART_ACCOUNTS, REMOVE_CHART_ACCOUNTS, UPDATE_CHART_ACCOUNTS } from '../graphql/mutations/chart-accounts.mutation';

@Injectable({
  providedIn: 'root'
})
export class ChartOfAccountsService {

  constructor(private apollo: Apollo) { }

  fetchChartAccounts(search: any, accountType?: any): Observable<any> {
    return this.apollo
      .use('accounts')
      .watchQuery<any>({
        query: ACCOUNTS,
        variables: {search, accountType},
        fetchPolicy: 'network-only'
      })
      .valueChanges.pipe(
        map((result) => result.data?.accounts || [])
      );
  }

  createChartAccounts(createChartOfAccountInput: any): Observable<any> {
    return this.apollo
      .use('accounts')
      .mutate({
        mutation: CREATE_CHART_ACCOUNTS,
        variables: { 
          createAccountInput: createChartOfAccountInput,
        },
        fetchPolicy: 'network-only'
      })
      .pipe(
        map((result: any) => result.data.createAccount || [])
      );
  }

  updateChartOfAccount( updateChartOfAccountInput: any): Observable<any> {
    return this.apollo
      .use('accounts')
      .mutate({
        mutation: UPDATE_CHART_ACCOUNTS,
        variables: { 
          updateAccountInput: updateChartOfAccountInput
        },
        fetchPolicy: 'network-only'
      })
      .pipe(
        map((result: any) => result.data.updateAccount || [])
      );
  }

  removeChartOfAccount(id: any): Observable<any> {
    return this.apollo
      .use('accounts')
      .mutate({
        mutation: REMOVE_CHART_ACCOUNTS,
        variables: { 
          id
        },
        fetchPolicy: 'network-only'
      })
      .pipe(
        map((result: any) => result.data.removeAccount || [])
      );
  }

  chartOfAccountsById(id:any): Observable<any> {
    return this.apollo
      .use('accounts')
      .watchQuery<any>({
        query: GET_ACCOUNT_BY_ID,
        variables: { 
            id
         },
        fetchPolicy: 'network-only'
      })
      .valueChanges.pipe(
        map((result) => result.data?.account || [])
      );
  }


}
